import React from 'react';
import { Box, Typography, Container, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import GoogleLoginButton from '../Auth/GoogleLoginButton';

const HeroContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  minHeight: '80vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: `linear-gradient(135deg, 
    ${theme.palette.primary.main} 0%, 
    ${theme.palette.primary.dark} 50%, 
    ${theme.palette.secondary.main} 100%)`,
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Ccircle cx='30' cy='30' r='4'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
    opacity: 0.3,
  },
}));

const ContentBox = styled(Box)(({ theme }) => ({
  position: 'relative',
  zIndex: 10,
  textAlign: 'center',
  color: 'white',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  maxWidth: '100%',
}));

const BrandName = styled(Typography)(({ theme }) => ({
  fontSize: '3.5rem',
  fontWeight: 700,
  marginBottom: theme.spacing(1),
  letterSpacing: '-0.02em',
  background: 'linear-gradient(45deg, #ffffff 30%, rgba(255,255,255,0.8) 90%)',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  textShadow: '0 2px 10px rgba(0,0,0,0.1)',
  [theme.breakpoints.down('md')]: {
    fontSize: '2.5rem',
  },
}));

const Tagline = styled(Typography)(({ theme }) => ({
  fontSize: '1.25rem',
  fontWeight: 400,
  marginBottom: theme.spacing(4),
  opacity: 0.95,
  maxWidth: '600px',
  margin: `0 auto ${theme.spacing(4)}px auto`,
  lineHeight: 1.6,
  textAlign: 'center',
  [theme.breakpoints.down('md')]: {
    fontSize: '1rem',
    marginBottom: theme.spacing(3),
  },
}));

const Divider = styled(Box)(({ theme }) => ({
  width: '80px',
  height: '4px',
  backgroundColor: 'rgba(255,255,255,0.8)',
  margin: `${theme.spacing(2)} auto ${theme.spacing(3)}`,
  borderRadius: '2px',
}));

const HeroSection = ({ onLogin, onError }) => {
  return (
    <HeroContainer>
      <Container maxWidth="md">
        <ContentBox>
          {/* Brand */}
          <BrandName variant="h1">
            Marshmallow AI
          </BrandName>
          <Divider />

          {/* Tagline */}
          <Tagline>
            Search your LinkedIn network in simple plain English.
          </Tagline>
          
          {/* CTA */}
          <Box sx={{ 
            display: 'flex', 
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            mt: 2
          }}>
            <GoogleLoginButton 
              onSuccess={onLogin}
              onError={onError}
            />
          </Box>
        </ContentBox>
      </Container>
    </HeroContainer>
  );
};

export default HeroSection;